import bgImgLeft from '@/assets/images/bg-left.avif';
import bgImgRight from '@/assets/images/bg-right.avif';
import vectorImg1 from '@/assets/images/vector-1.svg';
import vectorImg2 from '@/assets/images/vector-2.svg';
import vectorImg3 from '@/assets/images/vector-3.svg';

export function SurfaceBackground() {
  return (
    <div className='fixed inset-0 overflow-hidden'>
      <div className='fixed top-[-100px] left-[-200px] w-[1000px] h-[1200px] bg-purple-400/80 opacity-30 blur-[400px] rounded-full' />
      <div className='fixed bottom-[-200px] right-[-200px] w-[1000px] h-[1000px] bg-yellow-400/80 opacity-50 blur-[600px] rounded-full' />
    </div>
  );
}

export function SurfaceBackgroundImg() {
  return (
    <div className='fixed inset-0 overflow-hidden'>
      <img src={bgImgLeft} alt='Background' className='fixed top-0 left-0' />
      <img
        src={bgImgRight}
        alt='Background'
        className='fixed bottom-0 right-0'
      />
    </div>
  );
}

export function SurfaceBackgroundPolygons() {
  return (
    <>
      <img
        src={vectorImg2}
        alt='Background'
        className='size-38 fixed top-[700px] right-1/4 translate-x-[200px]'
      />
      <img
        src={vectorImg1}
        alt='Background'
        className='size-64 fixed top-[520px] right-1/4 translate-x-[200px]'
      />
      <img
        src={vectorImg3}
        alt='Background'
        className='size-96 fixed top-[100px] right-1/4 translate-x-[100px]'
      />
    </>
  );
}
